import type * as Types from 'graphql/types';

import type { DocumentNode } from 'graphql';
import type * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@hotelplan/libs.context.req-ctx';
const defaultOptions = {} as const;
export type GetPdpRatingQueryVariables = Types.Exact<{
  id: Types.Scalars['String'];
  context?: Types.InputMaybe<Types.RequestContextInput>;
}>;

export type GetPdpRatingQuery = {
  __typename?: 'Query';
  pdp: {
    __typename?: 'PdpContext';
    content: {
      __typename?: 'PdpContainer';
      tripAdvisor?: {
        __typename?: 'PdpTripAdvisorComponent';
        taRating: {
          __typename?: 'TripAdvisorRating';
          rating?: number | null;
          count?: number | null;
        };
        subratings: Array<{
          __typename?: 'TripAdvisorSubrating';
          name: string;
          rating: number;
        }>;
        reviews: Array<{
          __typename?: 'TripAdvisorReview';
          rating?: number | null;
          author?: string | null;
          date?: string | null;
          region?: string | null;
          message?: {
            __typename?: 'TextComponent';
            title: string;
            text: string;
          } | null;
          subratings?: Array<{
            __typename?: 'TripAdvisorSubrating';
            name: string;
            rating: number;
          }> | null;
        }>;
      } | null;
    };
  };
};

export type TaRatingFragment = {
  __typename?: 'TripAdvisorRating';
  rating?: number | null;
  count?: number | null;
};

export type TaSubRatingFragment = {
  __typename?: 'TripAdvisorSubrating';
  name: string;
  rating: number;
};

export type TaReviewFragment = {
  __typename?: 'TripAdvisorReview';
  rating?: number | null;
  author?: string | null;
  date?: string | null;
  region?: string | null;
  message?: {
    __typename?: 'TextComponent';
    title: string;
    text: string;
  } | null;
  subratings?: Array<{
    __typename?: 'TripAdvisorSubrating';
    name: string;
    rating: number;
  }> | null;
};

export const TaRatingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'taRating' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TripAdvisorRating' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TaSubRatingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'taSubRating' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TripAdvisorSubrating' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TaReviewFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'taReview' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TripAdvisorReview' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
          { kind: 'Field', name: { kind: 'Name', value: 'author' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'message' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subratings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rating' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetPdpRatingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPdpRating' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'context' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'RequestContextInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pdp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'context' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'context' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tripAdvisor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'taRating' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'taRating' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subratings' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'taSubRating',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reviews' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'taReview' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...TaRatingFragmentDoc.definitions,
    ...TaSubRatingFragmentDoc.definitions,
    ...TaReviewFragmentDoc.definitions,
  ],
} as unknown as DocumentNode;

/**
 * __useGetPdpRatingQuery__
 *
 * To run a query within a React component, call `useGetPdpRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPdpRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPdpRatingQuery({
 *   variables: {
 *      id: // value for 'id'
 *      context: // value for 'context'
 *   },
 * });
 */
export function useGetPdpRatingQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetPdpRatingQuery,
    GetPdpRatingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetPdpRatingQuery,
    GetPdpRatingQueryVariables
  >(GetPdpRatingDocument, options);
}
export function useGetPdpRatingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetPdpRatingQuery,
    GetPdpRatingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetPdpRatingQuery,
    GetPdpRatingQueryVariables
  >(GetPdpRatingDocument, options);
}
export type GetPdpRatingQueryHookResult = ReturnType<
  typeof useGetPdpRatingQuery
>;
export type GetPdpRatingLazyQueryHookResult = ReturnType<
  typeof useGetPdpRatingLazyQuery
>;
export type GetPdpRatingQueryResult = Apollo.QueryResult<
  GetPdpRatingQuery,
  GetPdpRatingQueryVariables
>;
